import {
  SearchDropdownType,
  SearchFieldElement,
} from "@/app/layouts/standard/header/search-bar/search-bar-dropdown/searchFieldDropdown";
import { SearchFieldDropdownElement } from "@/app/layouts/standard/header/search-bar/search-bar-dropdown/searchFieldDropdownElement";
import { MAX_SEARCH_HISTORY_DISPLAY } from "@/utils/searchHistoryStorage";
import styles from "./searchFieldDropdown.module.scss";

export const SearchHistoryDropdown = ({
  searchHistory,
  dropdownItemChooseCallback,
  dropdownItemDismissCallback,
  reportClosedCallback,
}: AlgoliaSearchHistoryProps) => {
  return (
    <div className={styles["dropdownContentContainer"]}>
      {searchHistory?.slice(0, MAX_SEARCH_HISTORY_DISPLAY).map((searchEntry, index) => {
        return (
          <SearchFieldDropdownElement
            key={index}
            elementDetails={{
              dropdownType: SearchDropdownType.LOCAL_HISTORY,
              label: searchEntry,
              id: index + "",
            }}
            dropdownItemChooseCallback={dropdownItemChooseCallback}
            dropdownItemDismissCallback={dropdownItemDismissCallback}
          />
        );
      })}
    </div>
  );
};

type AlgoliaSearchHistoryProps = {
  searchHistory: string[] | undefined | null;
  dropdownItemChooseCallback: (elementDetails: SearchFieldElement) => void;
  dropdownItemDismissCallback?: (elementDetails: SearchFieldElement) => void;
  reportClosedCallback: (dropdownType: SearchDropdownType) => void;
};
